import React, { Component } from 'react';

class SliderControl extends Component {

    render() {
        const { label, value, min, max, step, onChange } = this.props;

        return (
            <div className="mb-3">
                <div className="flex justify-between items-center mb-1">
                    <label className="text-xs text-gray-500">{label}</label>
                    <span className="text-xs text-gray-600">{typeof value === 'number' ? (step < 1 ? value.toFixed(2) : Math.round(value)) : value}</span>
                </div>
                <input
                    type="range"
                    min={min !== undefined ? min : 0}
                    max={max !== undefined ? max : 100}
                    step={step !== undefined ? step : 1}
                    value={value || 0}
                    onChange={(e) => onChange(parseFloat(e.target.value))}
                    className="w-full"
                />
            </div>
        );
    }
}

export default SliderControl;
